import { FlexBox } from '@dixa/lib-shared-habla';
import { Controller } from 'react-hook-form';

import { MessengerTranslatedLanguage } from 'components/settings/components/sections/dixaMessenger/views/settings/components/generalSettings/languageSettings/languages';
import { messengerSettingsFormFields } from 'components/settings/components/sections/dixaMessenger/views/settings/types';
import { CharLimitFieldText } from 'components/shared/charLimitFieldText';

const MAX_LENGTH = 85;
const BUTTON_LABEL_MAX_LENGTH = 35;

interface TitleDescriptionEditorProps {
  currentLangCode: MessengerTranslatedLanguage;
}

export function DynamicStringsEditor({
  currentLangCode,
}: TitleDescriptionEditorProps): JSX.Element {
  // In 'react-hook-form' nested fields use a "." notation to separate the parent field from the child field
  const titleFieldName = `${messengerSettingsFormFields.title}.${currentLangCode}`;
  const descriptionFieldName = `${messengerSettingsFormFields.description}.${currentLangCode}`;
  const startConversationFieldName = `${messengerSettingsFormFields.startConversation}.${currentLangCode}`;

  return (
    <FlexBox flexDirection="column" flex="1" gap="400">
      <Controller
        // Key is needed to reinsantiate the component when the language changes
        key={titleFieldName}
        name={titleFieldName}
        defaultValue=""
        render={({ field, fieldState }) => (
          <CharLimitFieldText
            input={field}
            label="Title"
            inputType="text"
            placeholder="Custom title"
            maxLength={MAX_LENGTH}
            helpIcon={{ text: 'Leave empty to use the default title' }}
            meta={{
              error: fieldState.error?.message,
              touched: fieldState.isTouched,
            }}
          />
        )}
      />

      <Controller
        // Key is needed to reinsantiate the component when the language changes
        key={descriptionFieldName}
        name={descriptionFieldName}
        defaultValue=""
        render={({ field, fieldState }) => (
          <CharLimitFieldText
            input={field}
            label="Description"
            inputType="textarea"
            placeholder="Custom description"
            maxLength={MAX_LENGTH}
            style={{ maxHeight: '90px' }}
            helpIcon={{ text: 'Leave empty to use the default message' }}
            meta={{
              error: fieldState.error?.message,
              touched: fieldState.isTouched,
            }}
          />
        )}
      />

      <Controller
        // Key is needed to reinsantiate the component when the language changes
        key={startConversationFieldName}
        name={startConversationFieldName}
        defaultValue=""
        render={({ field, fieldState }) => (
          <CharLimitFieldText
            input={field}
            label="Start a Conversation"
            inputType="text"
            placeholder="Custom start conversation button label"
            maxLength={BUTTON_LABEL_MAX_LENGTH}
            helpIcon={{ text: 'Leave empty to use the default message' }}
            meta={{
              error: fieldState.error?.message,
              touched: fieldState.isTouched,
            }}
          />
        )}
      />
    </FlexBox>
  );
}
